// Cache key for the editor-only error entry of a Preview Module whose question_id
// resolves to zero or several GO pages.
export default function goPreviewErrorKey(questionId) {
  return `go-preview-error:${questionId}`;
}

// Collaborative-editing lock key for a GO's slide; every GO entry point must use it.
export function goLockKey(pageId) {
  return `go_${pageId}`;
}

// edde's model_type vocabulary ('t chart', 'venn diagram', ...) differs from
// PlayerViewer's dispatch strings ('t_chart', 'venn_diagram', ...); see goPlayerViewerSubtype.
export const GO_MODEL_TYPE_TABLE = 'table';
export const GO_MODEL_TYPE_T_CHART = 't chart';
export const GO_MODEL_TYPE_FRAYER = 'frayer';
export const GO_MODEL_TYPE_VENN_DIAGRAM = 'venn diagram';
export const GO_MODEL_TYPE_BUBBLE_MAP = 'bubble map';

const GO_MODEL_TYPE_TO_PLAYER_SUBTYPE = {
  [GO_MODEL_TYPE_TABLE]: 'table',
  [GO_MODEL_TYPE_T_CHART]: 't_chart',
  [GO_MODEL_TYPE_VENN_DIAGRAM]: 'venn_diagram',
  [GO_MODEL_TYPE_BUBBLE_MAP]: 'bubble_map',
  [GO_MODEL_TYPE_FRAYER]: 'frayer_model',
};

export function goPlayerViewerSubtype(modelType) {
  return GO_MODEL_TYPE_TO_PLAYER_SUBTYPE[modelType] || modelType;
}

// Types whose renderer reads meaning from the grid shape (the Frayer term and Bubble Map
// centre sit in the middle cell; Venn columns are circles), so rows, columns and merges are locked.
export const GO_FIXED_LAYOUT_MODEL_TYPES = new Set([
  GO_MODEL_TYPE_FRAYER,
  GO_MODEL_TYPE_VENN_DIAGRAM,
  GO_MODEL_TYPE_BUBBLE_MAP,
]);

// Types whose renderer reads a fixed number of rows (a T-Chart's header and body rows), so
// only the row commands are locked.
export const GO_FIXED_ROWS_MODEL_TYPES = new Set([GO_MODEL_TYPE_T_CHART]);

// Starter grid per type, kept in step with the backend by the shared go_contract starter
// fixtures. `headerRow` marks row 0 as the header row.
export const GO_STARTER_GRID_BY_MODEL_TYPE = {
  [GO_MODEL_TYPE_TABLE]: { rows: 2, cols: 2 },
  [GO_MODEL_TYPE_T_CHART]: { rows: 2, cols: 2, headerRow: true },
  [GO_MODEL_TYPE_FRAYER]: { rows: 3, cols: 3 },
  [GO_MODEL_TYPE_VENN_DIAGRAM]: { rows: 2, cols: 3 },
  [GO_MODEL_TYPE_BUBBLE_MAP]: { rows: 3, cols: 3 },
};

export const GO_LANG_ENGLISH = 'eng';
export const GO_LANG_SPANISH = 'spa';

// The languages the GO panel edits, in toggle order.
export const GO_EDITING_LANGUAGES = [
  { lang: GO_LANG_ENGLISH },
  { lang: GO_LANG_SPANISH },
];
